import React, { useContext, useEffect, useState } from 'react';
import { Calendar } from '@pcln/date-picker';
import { Box } from 'pcln-design-system';
import { submitChatMessages } from '../../submitChatMessages';
import { ChatbotDataContext } from '../../context/ChatbotDataContext';
import analytics from '../../analytics/analytics';
import { format } from 'date-fns/format';
import { parse } from 'date-fns/parse';
import { differenceInCalendarDays } from 'date-fns/differenceInCalendarDays';
const CalendarComponent = ({
  markerComponentProps,
  isLastMessage
}) => {
  const [resolvedStartDate, setResolvedStartDate] = useState('');
  const [resolvedEndDate, setResolvedEndDate] = useState('');
  const [numberOfNights, setNumberOfNights] = useState(0);
  const {
    setCachedMessages,
    setCachedPrompts,
    submitChatMessagesPayload,
    handleMarkerResponse,
    fetchRequestOptions,
    markerComponents,
    setErrorMessage,
    setLoadingStatus,
    setOpenErrorComponent,
    chatMessages,
    setChatMessages,
    prompts,
    setStreamingText,
    setIsDisablingInputValue,
    setPrompts,
    isMobile
  } = useContext(ChatbotDataContext);
  const {
    isSessionActive
  } = submitChatMessagesPayload;
  const submitChatMessagesOptions = {
    setChatMessages,
    setPrompts,
    setStreamingText,
    setLoadingStatus,
    setErrorMessage,
    setIsDisablingInputValue,
    // Cache control
    cacheControl: {
      setCachedMessages,
      setCachedPrompts
    },
    requestOptions: fetchRequestOptions,
    markerComponents,
    handleMarkerResponse
  };
  useEffect(() => {
    if (resolvedStartDate && resolvedEndDate) {
      let nightsText = '';
      if (numberOfNights && numberOfNights > 1) {
        nightsText = ` (${numberOfNights} nights)`;
      } else if (numberOfNights && numberOfNights === 1) {
        nightsText = ` (${numberOfNights} night)`;
      }
      const chatContent = `Search for hotels with Check-in date - ${resolvedStartDate} and check-out date - ${resolvedEndDate}${nightsText}.`;
      const chatMessage = {
        content: chatContent,
        date: new Date(),
        role: 'user'
      };
      const promptMessage = {
        content: chatContent,
        role: 'user'
      };
      chatMessages.pop();
      const updatedChatMessages = [...chatMessages, chatMessage];
      setChatMessages(updatedChatMessages);
      setCachedMessages(chatMessage);
      setCachedPrompts(promptMessage);
      // this would not be needed for Chat Persistence and could be removed once we declare chat persistence
      // test as winner. Reason for this is to remove the message to edit from the prompt we send to the LLM
      // this confuses the Intent flow to think we still want to edit and thus puts the process of date selection in a continuous loop
      prompts.pop();
      submitChatMessages(Object.assign({
        submitChatMessagesPayload: Object.assign(Object.assign({}, submitChatMessagesPayload), {
          prompts: isSessionActive ? [promptMessage] : [...prompts, promptMessage]
        }),
        setOpenErrorComponent,
        chatMessages: updatedChatMessages
      }, submitChatMessagesOptions)).catch(e => {
        analytics.log({
          message: e === null || e === void 0 ? void 0 : e.message,
          source: 'CalendarComponent'
        });
      });
    }
  }, [resolvedEndDate, resolvedStartDate]);
  const calculateNights = (startDate, endDate) => {
    if (startDate && endDate) {
      const start = new Date(parseInt(startDate.substring(0, 4), 10), parseInt(startDate.substring(4, 6), 10) - 1, parseInt(startDate.substring(6, 8), 10));
      const end = new Date(parseInt(endDate.substring(0, 4), 10), parseInt(endDate.substring(4, 6), 10) - 1, parseInt(endDate.substring(6, 8), 10));
      return differenceInCalendarDays(end, start);
    }
    return 0;
  };
  function handleSelectedDates(e, f) {
    if (e && f) {
      if ((f === null || f === void 0 ? void 0 : f.startDate) && (f === null || f === void 0 ? void 0 : f.endDate)) {
        setNumberOfNights(calculateNights(f.startDate, f.endDate));
        const parsedStartDate = parse(f === null || f === void 0 ? void 0 : f.startDate, 'yyyyMMdd', new Date());
        const parsedEndDate = parse(f === null || f === void 0 ? void 0 : f.endDate, 'yyyyMMdd', new Date());
        setResolvedStartDate(format(parsedStartDate, 'EEEE, MMMM dd, yyyy'));
        setResolvedEndDate(format(parsedEndDate, 'EEEE, MMMM dd, yyyy'));
      }
    }
  }
  function handleCalenderRef(ref) {
    ref.style.position = 'relative';
    ref.style.marginLeft = '30px';
    ref.scrollIntoView({
      behavior: 'smooth'
    });
  }
  if (!isLastMessage) {
    return null;
  }
  return React.createElement(Box, {
    mb: 2,
    maxHeight: isMobile ? '300px' : null,
    overflowY: 'auto'
  }, React.createElement(Calendar, {
    monthsToShow: 1,
    isMobile: isMobile,
    monthWidthPx: 300,
    onChange: handleSelectedDates,
    setCalendarRef: handleCalenderRef,
    calendarWrapperStyles: {
      boxShadow: 'lg'
    }
  }));
};
export default CalendarComponent;